/**
 * The comparable form of an edited value (BB-20): object keys in order, `undefined` the same as a missing key, and
 * trailing spaces at line ends dropped — so opening a form, or typing and deleting, is never a change.
 */
export function normalize(value: unknown): unknown {
  if (typeof value === 'string') return value.replace(/[ \t]+$/gm, '');
  if (Array.isArray(value)) return value.map(normalize);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, v]) => v !== undefined)
        .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
        .map(([k, v]) => [k, normalize(v)]),
    );
  }
  return value;
}

export const sameContent = (a: unknown, b: unknown): boolean => JSON.stringify(normalize(a)) === JSON.stringify(normalize(b));
